import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { httpInterceptor } from './services/http/http.interceptor';
import { HttpService } from './services/http/http.service';
import { AuthenticationService } from './services/authentication/authentication.service';
import { AuthenticationGuard } from './services/authentication/authentication.guard';
import { AuthorizationService } from './services/authorization/authorization.service';
import { SetPasswordGuard } from '../shared/guards/set-password.guard';
import { LabConfigurationGuard } from '../shared/guards/lab-configuration.guard';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    AuthenticationService,
    AuthorizationService,
    AuthenticationGuard,
    SetPasswordGuard,
    LabConfigurationGuard,
    HttpService,
    { provide: HTTP_INTERCEPTORS, useClass: httpInterceptor, multi: true }]
})
export class CoreModule { }
